export default __webpack_public_path__ + "static/media/bg-character-img-3.576c9723.png";